import API from '..';
const ENTITY = 'companies';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
